import React, { Fragment, useCallback, useState } from 'react'
import { Route, Switch, useParams, withRouter } from 'react-router-dom'

import Button from '../../../components/Button/Button'
import ConfirmationModal from '../../../modules/ConfirmationModal/ConfirmationModal'
import GenericErrorModal from '../../../modules/GenericErrorModal/GenericErrorModal'
import OldPlayerFormModal from './OldPlayerFormModal'
import OldPlayerInviteModal from './OldPlayerInviteModal'
import PlayerCard from '../../../components/Cards/PlayerCard/PlayerCard'
import { oldPost } from '../../../helpers/requestOld'
import t from '../../../helpers/i18n'
import { useSelector } from 'react-redux'
import Modal from '../../../components/Modal/Modal'
import ModalHeader from '../../../components/Modal/ModalHeader'
import ModalContent from '../../../components/Modal/ModalContent'
import './OldTeamPlayersView.scss'

const OldTeamPlayersView = withRouter(({ history, team, onPlayersChanged }) => {
  const profile = useSelector(state => state.profile)
  const [playerToRemove, setPlayerToRemove] = useState()
  const [error, setError] = useState()
  const { teamId } = useParams()

  const handleClose = useCallback(() => {
    history.push('/cm/teams/' + teamId + '/players')
    onPlayersChanged()
  }, [teamId, history, onPlayersChanged])

  const handleOpen = useCallback(
    (playerId) => history.push('/cm/teams/' + teamId + '/players/' + playerId),
    [teamId, history]
  )
  const handleInvite = useCallback(
    () => history.push('/cm/teams/' + teamId + '/players/invite'),
    [teamId, history]
  )

  const handleRemove = useCallback(() => {
    oldPost(
      '/delegate/teams/' +
        teamId +
        '/players/' +
        playerToRemove.player_id +
        '/remove',
      {}
    )
      .then(() => {
        // TODO: show a toast?
        onPlayersChanged()
      })
      .catch((error) => setError(error))
      .finally(() => setPlayerToRemove(false))
  }, [teamId, playerToRemove, onPlayersChanged])

  return (
    <Fragment>
      <div className='-heading'>
        <div className='-left overline-label-large-bold'>
          {t('titles.Players')}
        </div>
        <div className='-left label-small-basic'>
          ({(team && team.players.length) || ''})
        </div>
        <div className='-center'></div>
        {team?.registerOpen && team.limitPlayers > 0 &&
          <div className='-right label-small-basic'>
            Límite de {team.limitPlayers} jugadores
          </div>      
        }
        <div className='-right'>
          {team?.registerOpen && 
            <>
              {profile.products.BETA &&
                <Button
                  label={t('buttons.Invite')}
                  size='field-sized'
                  type='dark'
                  color='green'
                  icon='SearchIcon'
                  onClick={handleInvite}
                />
              }
              <Button
                label={t('buttons.Add')}
                size='field-sized'
                type='dark'
                color='green'
                icon='GetIcon'
                onClick={() => handleOpen('new')}
              />
            </>
          }
          {team && !team.registerOpen && 
            <div className="caption-default-medium">Registro cerrado</div>          
          }
        </div>
      </div>
      <div className='-content'>
        {team && team.players && team.players.map((player) => (
          <PlayerCard
            key={player.player_id}
            firstName={player.first_name}
            lastName={player.last_name}
            avatar={player.avatar}
            birthDate={player.birth_date}
            onClick={() => handleOpen(player.player_id)}
            onRemove={() => setPlayerToRemove(player)}
          />
        ))}
        {team && team.players?.length === 0 &&
          <div className="caption-default-medium">No hay jugadores registrados.</div>        
        }
      </div>

      <Switch>
        <Route exact path='/cm/teams/:teamId/players/invite'>
          <OldPlayerInviteModal onCloseRequested={handleClose} />
        </Route>
        <Route exact path='/cm/teams/:teamId/players/:playerId'>
          {team && (team.limitPlayers === 0 || team.limitPlayers > team.players.length) &&
            <OldPlayerFormModal onCloseRequested={handleClose} />
          }
          {team && team.limitPlayers > 0 && team.limitPlayers <= team.players.length &&
            <Modal onCloseRequested={handleClose}>
              <ModalHeader title="Límite de Jugadores" back={false} />
              <ModalContent dialog>
                <div className="-message caption-small-basic">Se alcanzó el límite de jugadores permitido para los equipos en esta competición.</div>
              </ModalContent>
            </Modal>
          }
        </Route>
      </Switch>

      {playerToRemove && (
        <ConfirmationModal
          title={t('titles.Remove_player')}
          description={t(
            'descriptions.Are_you_sure_you_want_to_remove_from_this_team',
            playerToRemove.first_name + ' ' + playerToRemove.last_name
          )}
          actionLabel={'Remove'}
          danger
          onAccepted={handleRemove}
          onCancelled={() => setPlayerToRemove(false)}
        />
      )}

      {error && (
        <GenericErrorModal
          error={error}
          i18nPrefix='OldTeamPlayersView'
          onCloseRequested={() => setError(false)}
        />
      )}
    </Fragment>
  )
})

export default OldTeamPlayersView
